var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultBsProjectCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 263,
    viewBox: "0 0 256 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11642_35503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.0068 203.001L27.1295 164.911C24.4311 163.327 24.5147 159.398 27.2781 157.929L125.136 105.943C126.2 105.377 127.463 105.322 128.572 105.792L227.765 147.808C230.784 149.087 231.067 153.254 228.249 154.929L188.367 178.644C185.759 180.194 185.759 183.969 188.367 185.52L194.451 189.137C197.02 190.665 197.067 194.369 194.537 195.961L147.33 225.669C146.054 226.472 144.434 226.489 143.141 225.713L102.566 201.368C101.219 200.56 99.5228 200.615 98.231 201.509L96.3088 202.84C95.0284 203.726 93.3498 203.789 92.0068 203.001Z",
    fill: "#D1D1D1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.0068 199.219L27.1295 161.13C24.4311 159.546 24.5147 155.616 27.2781 154.148L125.136 102.161C126.2 101.596 127.463 101.541 128.572 102.011L227.765 144.027C230.784 145.305 231.067 149.473 228.249 151.148L188.367 174.862C185.759 176.413 185.759 180.188 188.367 181.739L194.451 185.356C197.02 186.884 197.067 190.588 194.537 192.18L147.33 221.888C146.054 222.691 144.434 222.708 143.141 221.932L102.566 197.587C101.219 196.778 99.5228 196.834 98.231 197.728L96.3088 199.059C95.0284 199.945 93.3498 200.008 92.0068 199.219Z",
    fill: "#EFEFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0124 194.508L33.8332 160.674C31.1131 159.092 31.2003 155.134 33.9875 153.673L124.225 106.385C125.27 105.837 126.504 105.779 127.597 106.226L220.093 144.085C223.14 145.332 223.459 149.523 220.635 151.217L181.239 174.855C178.643 176.412 178.651 180.176 181.252 181.723L187.337 185.341C189.913 186.873 189.952 190.587 187.41 192.173L147.327 217.176C146.052 217.971 144.44 217.985 143.152 217.212L102.567 192.861C101.219 192.053 99.5237 192.108 98.2318 193.002L96.3001 194.339C95.0246 195.222 93.3535 195.288 92.0124 194.508Z",
    fill: "url(#paint0_linear_11642_35503)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.394 24.2944L172.404 147.856L127.649 173.913L127.641 50.3511L172.394 24.2944Z",
    fill: "url(#paint1_linear_11642_35503)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.64 50.3493L127.648 173.911L86.6896 150.267L86.6816 26.7026L127.64 50.3493Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M172.393 24.2937L127.64 50.3503L86.6816 26.7036L131.44 0.646973L172.393 24.2937Z",
    fill: "#F4F4F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.338 24.3045L160.727 26.4055L131.446 9.47739L98.3753 28.7649L94.7617 26.6878L131.446 5.32324L164.338 24.3045Z",
    fill: "#DCDCDC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M160.727 26.4047L127.622 45.6656L98.375 28.7641L131.446 9.47656L160.727 26.4047Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M204.137 65.2158L204.145 149.236L173.71 166.953L173.705 82.9349L204.137 65.2158Z",
    fill: "url(#paint2_linear_11642_35503)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M173.705 82.9356L173.71 166.953L145.861 150.877L145.854 66.8569L173.705 82.9356Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M204.137 65.2164L173.705 82.9354L145.854 66.8567L176.288 49.1377L204.137 65.2164Z",
    fill: "#F4F4F9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M198.66 65.2229L196.202 66.6528L176.294 55.1411L153.806 68.2559L151.348 66.8446L176.294 52.3184L198.66 65.2229Z",
    fill: "#DCDCDC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M196.201 66.6519L173.694 79.7481L153.805 68.255L176.293 55.1401L196.201 66.6519Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M165.412 84.7104V90.6541L169.151 92.8164V91.9163L166.272 90.2493V85.2031L165.412 84.7104Z",
    fill: "#BCBCBC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M166.271 85.2041V90.2503L169.15 91.9173V86.8738L166.271 85.2041Z",
    fill: "#DCDCDC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M159.99 81.5151V87.4588L163.729 89.6237V88.7237L160.85 87.0567V82.0104L159.99 81.5151Z",
    fill: "#BCBCBC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M160.85 82.0103V87.0565L163.728 88.7235V83.6772L160.85 82.0103Z",
    fill: "#DCDCDC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M154.566 78.3213V84.2649L158.308 86.4272V85.5298L155.429 83.8628V78.8166L154.566 78.3213Z",
    fill: "#BCBCBC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M155.43 78.8164V83.8626L158.308 85.5296V80.4834L155.43 78.8164Z",
    fill: "#DCDCDC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M149.145 75.127V81.0732L152.883 83.2355V82.3355L150.007 80.6685V75.6223L149.145 75.127Z",
    fill: "#BCBCBC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M150.008 75.6221V80.6683L152.884 82.3353V77.2917L150.008 75.6221Z",
    fill: "#DCDCDC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M165.412 93.5518V99.4927L169.151 101.658V100.758L166.272 99.0906V94.0444L165.412 93.5518Z",
    fill: "#BCBCBC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M166.271 94.0435V99.0897L169.15 100.757V95.7131L166.271 94.0435Z",
    fill: "#DCDCDC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M159.99 90.356V96.2996L163.729 98.4645V97.5645L160.85 95.8975V90.8513L159.99 90.356Z",
    fill: "#BCBCBC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M160.85 90.8521V95.8983L163.728 97.5653V92.5217L160.85 90.8521Z",
    fill: "#DCDCDC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M154.566 87.1636V93.1072L158.308 95.2695V94.3721L155.429 92.7024V87.6589L154.566 87.1636Z",
    fill: "#BCBCBC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M155.43 87.6587V92.7023L158.308 94.3719V89.3257L155.43 87.6587Z",
    fill: "#DCDCDC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M149.145 83.9697V89.9134L152.883 92.0756V91.1756L150.007 89.5086V84.4624L149.145 83.9697Z",
    fill: "#BCBCBC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M150.008 84.4634V89.5096L152.884 91.1766V86.133L150.008 84.4634Z",
    fill: "#DCDCDC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M165.412 102.396V108.336L169.151 110.501V109.601L166.272 107.934V102.888L165.412 102.396Z",
    fill: "#BCBCBC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M166.271 102.889V107.935L169.15 109.602V104.559L166.271 102.889Z",
    fill: "#DCDCDC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M159.99 99.1987V105.142L163.729 107.305V106.407L160.85 104.738V99.694L159.99 99.1987Z",
    fill: "#BCBCBC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M160.85 99.6938V104.737L163.728 106.407V101.361L160.85 99.6938Z",
    fill: "#DCDCDC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M154.566 96.0068V101.95L158.308 104.113V103.213L155.429 101.546V96.5021L154.566 96.0068Z",
    fill: "#BCBCBC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M155.43 96.502V101.546L158.308 103.213V98.1689L155.43 96.502Z",
    fill: "#DCDCDC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M149.145 92.8145V98.7554L152.883 100.92V100.02L150.007 98.3533V93.3098L149.145 92.8145Z",
    fill: "#BCBCBC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M150.008 93.3096V98.3531L152.884 100.02V94.9766L150.008 93.3096Z",
    fill: "#DCDCDC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M165.412 111.239V117.183L169.151 119.343V118.445L166.272 116.775V111.732L165.412 111.239Z",
    fill: "#BCBCBC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M166.271 111.733V116.776L169.15 118.446V113.403L166.271 111.733Z",
    fill: "#DCDCDC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M159.99 108.045V113.989L163.729 116.151V115.253L160.85 113.584V108.54L159.99 108.045Z",
    fill: "#BCBCBC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M160.85 108.539V113.583L163.728 115.252V110.206L160.85 108.539Z",
    fill: "#DCDCDC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M154.566 104.851V110.795L158.308 112.957V112.06L155.429 110.39V105.346L154.566 104.851Z",
    fill: "#BCBCBC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M155.43 105.346V110.39L158.308 112.059V107.013L155.43 105.346Z",
    fill: "#DCDCDC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M149.145 101.658V107.602L152.883 109.764V108.864L150.007 107.197V102.151L149.145 101.658Z",
    fill: "#BCBCBC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M150.008 102.152V107.198L152.884 108.865V103.821L150.008 102.152Z",
    fill: "#DCDCDC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M165.412 120.082V126.023L169.151 128.188V127.288L166.272 125.618V120.575L165.412 120.082Z",
    fill: "#BCBCBC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M166.271 120.576V125.619L169.15 127.289V122.243L166.271 120.576Z",
    fill: "#DCDCDC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M159.99 116.889V122.832L163.729 124.995V124.097L160.85 122.428V117.384L159.99 116.889Z",
    fill: "#BCBCBC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M160.85 117.384V122.427L163.728 124.097V119.051L160.85 117.384Z",
    fill: "#DCDCDC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M154.566 113.695V119.638L158.308 121.801V120.901L155.429 119.234V114.187L154.566 113.695Z",
    fill: "#BCBCBC"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M155.43 114.188V119.234L158.308 120.901V115.858L155.43 114.188Z",
    fill: "#DCDCDC"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M149.145 110.501V116.445L152.883 118.604V117.707L150.007 116.04V110.994L149.145 110.501Z",
    fill: "#BCBCBC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M150.008 110.995V116.041L152.884 117.708V112.664L150.008 110.995Z",
    fill: "#DCDCDC"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M165.412 128.928V134.869L169.151 137.034V136.134L166.272 134.467V129.421L165.412 128.928Z",
    fill: "#BCBCBC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M166.271 129.422V134.468L169.15 136.135V131.092L166.271 129.422Z",
    fill: "#DCDCDC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M159.99 125.733V131.677L163.729 133.839V132.941L160.85 131.272V126.228L159.99 125.733Z",
    fill: "#BCBCBC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M160.85 126.228V131.272L163.728 132.941V127.895L160.85 126.228Z",
    fill: "#DCDCDC"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M154.566 122.54V128.484L158.308 130.646V129.746L155.429 128.079V123.033L154.566 122.54Z",
    fill: "#BCBCBC"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M155.43 123.034V128.08L158.308 129.747V124.703L155.43 123.034Z",
    fill: "#DCDCDC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M149.145 119.344V125.288L152.883 127.453V126.553L150.007 124.883V119.84L149.145 119.344Z",
    fill: "#BCBCBC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M150.008 119.839V124.883L152.884 126.553V121.509L150.008 119.839Z",
    fill: "#DCDCDC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M165.412 137.769V143.712L169.151 145.874V144.977L166.272 143.307V138.264L165.412 137.769Z",
    fill: "#BCBCBC"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M166.271 138.264V143.307L169.15 144.977V139.931L166.271 138.264Z",
    fill: "#DCDCDC"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M159.99 134.577V140.52L163.729 142.683V141.785L160.85 140.116V135.072L159.99 134.577Z",
    fill: "#BCBCBC"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M160.85 135.07V140.113L163.728 141.783V136.737L160.85 135.07Z",
    fill: "#DCDCDC"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M154.566 131.382V137.323L158.308 139.488V138.588L155.429 136.921V131.875L154.566 131.382Z",
    fill: "#BCBCBC"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M155.43 131.874V136.92L158.308 138.587V133.544L155.43 131.874Z",
    fill: "#DCDCDC"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M149.145 128.19V134.134L152.883 136.296V135.396L150.007 133.729V128.683L149.145 128.19Z",
    fill: "#BCBCBC"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M150.008 128.684V133.73L152.884 135.397V130.353L150.008 128.684Z",
    fill: "#DCDCDC"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M165.412 146.611V152.555L169.151 154.717V153.82L166.272 152.153V147.107L165.412 146.611Z",
    fill: "#BCBCBC"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M166.271 147.106V152.153L169.15 153.82V148.773L166.271 147.106Z",
    fill: "#DCDCDC"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M159.99 143.419V149.363L163.729 151.525V150.628L160.85 148.958V143.912L159.99 143.419Z",
    fill: "#BCBCBC"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M160.85 143.913V148.959L163.728 150.629V145.583L160.85 143.913Z",
    fill: "#DCDCDC"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M154.566 140.227V146.17L158.308 148.332V147.432L155.429 145.765V140.719L154.566 140.227Z",
    fill: "#BCBCBC"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M155.43 140.72V145.766L158.308 147.433V142.389L155.43 140.72Z",
    fill: "#DCDCDC"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M149.145 137.033V142.974L152.883 145.136V144.239L150.007 142.569V137.525L149.145 137.033Z",
    fill: "#BCBCBC"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M150.008 137.526V142.57L152.884 144.24V139.193L150.008 137.526Z",
    fill: "#DCDCDC"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M182.663 84.7095V90.6531L178.922 92.8154V91.9153L181.801 90.2483V85.2021L182.663 84.7095Z",
    fill: "#BCBCBC"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M181.801 85.2031V90.2494L178.922 91.9163V86.8728L181.801 85.2031Z",
    fill: "#DCDCDC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M188.085 81.5151V87.4588L184.344 89.6237V88.7237L187.222 87.0567V82.0104L188.085 81.5151Z",
    fill: "#BCBCBC"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M187.222 82.0103V87.0565L184.344 88.7235V83.6772L187.222 82.0103Z",
    fill: "#DCDCDC"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M193.506 78.3213V84.2649L189.768 86.4272V85.5298L192.646 83.8628V78.8166L193.506 78.3213Z",
    fill: "#BCBCBC"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M192.646 78.8164V83.8626L189.768 85.5296V80.4834L192.646 78.8164Z",
    fill: "#DCDCDC"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M198.928 75.127V81.0732L195.189 83.2355V82.3355L198.068 80.6685V75.6223L198.928 75.127Z",
    fill: "#BCBCBC"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M198.068 75.6221V80.6683L195.189 82.3353V77.2917L198.068 75.6221Z",
    fill: "#DCDCDC"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M182.663 93.5518V99.4927L178.922 101.658V100.758L181.801 99.0906V94.0444L182.663 93.5518Z",
    fill: "#BCBCBC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M181.801 94.0435V99.0897L178.922 100.757V95.7131L181.801 94.0435Z",
    fill: "#DCDCDC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M188.085 90.356V96.2996L184.344 98.4645V97.5645L187.222 95.8975V90.8513L188.085 90.356Z",
    fill: "#BCBCBC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M187.222 90.8511V95.8973L184.344 97.5643V92.5207L187.222 90.8511Z",
    fill: "#DCDCDC"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M193.506 87.1631V93.1067L189.768 95.269V94.3716L192.646 92.7019V87.6584L193.506 87.1631Z",
    fill: "#BCBCBC"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M192.646 87.6582V92.7018L189.768 94.3714V89.3252L192.646 87.6582Z",
    fill: "#DCDCDC"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M198.928 83.9697V89.9134L195.189 92.0756V91.1756L198.068 89.5086V84.4624L198.928 83.9697Z",
    fill: "#BCBCBC"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M198.068 84.4634V89.5096L195.189 91.1766V86.133L198.068 84.4634Z",
    fill: "#DCDCDC"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M182.663 102.396V108.336L178.922 110.501V109.601L181.801 107.934V102.888L182.663 102.396Z",
    fill: "#BCBCBC"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M181.801 102.889V107.935L178.922 109.602V104.559L181.801 102.889Z",
    fill: "#DCDCDC"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M188.085 99.1987V105.142L184.344 107.305V106.407L187.222 104.738V99.694L188.085 99.1987Z",
    fill: "#BCBCBC"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M187.222 99.6938V104.737L184.344 106.407V101.361L187.222 99.6938Z",
    fill: "#DCDCDC"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M193.506 96.0068V101.95L189.768 104.113V103.213L192.646 101.546V96.5021L193.506 96.0068Z",
    fill: "#BCBCBC"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M192.646 96.502V101.546L189.768 103.213V98.1689L192.646 96.502Z",
    fill: "#DCDCDC"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M198.928 92.8145V98.7554L195.189 100.92V100.02L198.068 98.3533V93.3098L198.928 92.8145Z",
    fill: "#BCBCBC"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M198.068 93.3101V98.3536L195.189 100.021V94.977L198.068 93.3101Z",
    fill: "#DCDCDC"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M182.663 111.239V117.183L178.922 119.343V118.445L181.801 116.775V111.732L182.663 111.239Z",
    fill: "#BCBCBC"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M181.801 111.733V116.776L178.922 118.446V113.403L181.801 111.733Z",
    fill: "#DCDCDC"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M188.085 108.044V113.988L184.344 116.15V115.252L187.222 113.583V108.539L188.085 108.044Z",
    fill: "#BCBCBC"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M187.222 108.539V113.583L184.344 115.252V110.206L187.222 108.539Z",
    fill: "#DCDCDC"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M193.506 104.85V110.793L189.768 112.956V112.058L192.646 110.388V105.345L193.506 104.85Z",
    fill: "#BCBCBC"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M192.646 105.345V110.388L189.768 112.058V107.012L192.646 105.345Z",
    fill: "#DCDCDC"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M198.928 101.658V107.602L195.189 109.764V108.864L198.068 107.197V102.151L198.928 101.658Z",
    fill: "#BCBCBC"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M198.068 102.152V107.198L195.189 108.865V103.821L198.068 102.152Z",
    fill: "#DCDCDC"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M182.663 120.082V126.023L178.922 128.188V127.288L181.801 125.618V120.575L182.663 120.082Z",
    fill: "#BCBCBC"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M181.801 120.576V125.619L178.922 127.289V122.243L181.801 120.576Z",
    fill: "#DCDCDC"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M188.085 116.889V122.832L184.344 124.995V124.097L187.222 122.428V117.384L188.085 116.889Z",
    fill: "#BCBCBC"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M187.222 117.384V122.427L184.344 124.097V119.051L187.222 117.384Z",
    fill: "#DCDCDC"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M193.506 113.693V119.637L189.768 121.799V120.899L192.646 119.232V114.186L193.506 113.693Z",
    fill: "#BCBCBC"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M192.646 114.187V119.233L189.768 120.9V115.857L192.646 114.187Z",
    fill: "#DCDCDC"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M198.928 110.501V116.445L195.189 118.604V117.707L198.068 116.04V110.994L198.928 110.501Z",
    fill: "#BCBCBC"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M198.068 110.995V116.041L195.189 117.708V112.664L198.068 110.995Z",
    fill: "#DCDCDC"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M182.663 128.925V134.866L178.922 137.031V136.131L181.801 134.464V129.418L182.663 128.925Z",
    fill: "#BCBCBC"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M181.801 129.418V134.465L178.922 136.132V131.088L181.801 129.418Z",
    fill: "#DCDCDC"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M188.085 125.731V131.675L184.344 133.837V132.94L187.222 131.27V126.227L188.085 125.731Z",
    fill: "#BCBCBC"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M187.222 126.227V131.27L184.344 132.94V127.894L187.222 126.227Z",
    fill: "#DCDCDC"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M193.506 122.539V128.482L189.768 130.644V129.744L192.646 128.077V123.031L193.506 122.539Z",
    fill: "#BCBCBC"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M192.646 123.03V128.077L189.768 129.743V124.7L192.646 123.03Z",
    fill: "#DCDCDC"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M198.928 119.344V125.288L195.189 127.453V126.553L198.068 124.883V119.84L198.928 119.344Z",
    fill: "#BCBCBC"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M198.068 119.839V124.883L195.189 126.553V121.509L198.068 119.839Z",
    fill: "#DCDCDC"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M182.663 137.766V143.709L178.922 145.872V144.974L181.801 143.304V138.261L182.663 137.766Z",
    fill: "#BCBCBC"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M181.801 138.261V143.304L178.922 144.974V139.928L181.801 138.261Z",
    fill: "#DCDCDC"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M188.085 134.574V140.517L184.344 142.68V141.782L187.222 140.113V135.069L188.085 134.574Z",
    fill: "#BCBCBC"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M187.222 135.069V140.112L184.344 141.782V136.736L187.222 135.069Z",
    fill: "#DCDCDC"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M193.506 131.38V137.321L189.768 139.486V138.586L192.646 136.919V131.873L193.506 131.38Z",
    fill: "#BCBCBC"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M192.646 131.872V136.918L189.768 138.585V133.542L192.646 131.872Z",
    fill: "#DCDCDC"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M198.928 128.187V134.131L195.189 136.293V135.393L198.068 133.726V128.68L198.928 128.187Z",
    fill: "#BCBCBC"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M198.068 128.681V133.727L195.189 135.394V130.35L198.068 128.681Z",
    fill: "#DCDCDC"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M182.663 146.611V152.555L178.922 154.717V153.82L181.801 152.153V147.107L182.663 146.611Z",
    fill: "#BCBCBC"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M181.801 147.106V152.153L178.922 153.82V148.773L181.801 147.106Z",
    fill: "#DCDCDC"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M188.085 143.419V149.363L184.344 151.525V150.628L187.222 148.958V143.912L188.085 143.419Z",
    fill: "#BCBCBC"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M187.222 143.913V148.959L184.344 150.629V145.583L187.222 143.913Z",
    fill: "#DCDCDC"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M193.506 140.225V146.169L189.768 148.331V147.431L192.646 145.764V140.718L193.506 140.225Z",
    fill: "#BCBCBC"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M192.646 140.719V145.765L189.768 147.432V142.388L192.646 140.719Z",
    fill: "#DCDCDC"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M198.928 137.033V142.974L195.189 145.136V144.239L198.068 142.569V137.525L198.928 137.033Z",
    fill: "#BCBCBC"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M198.068 137.526V142.57L195.189 144.24V139.193L198.068 137.526Z",
    fill: "#DCDCDC"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7865 130.262L49.7812 156.521L97.6418 184.393L97.6445 158.137L49.7865 130.262Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6452 158.138L97.6426 184.395L125.489 168.319L125.497 142.06L97.6452 158.138Z",
    fill: "#EBEBEB"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7871 130.262L97.6451 158.138L125.496 142.059L77.6386 114.184L49.7871 130.262Z",
    fill: "#F4F4F9"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2676 130.27L57.7254 131.697L77.6334 120.188L117.548 143.459L120.003 142.045L77.6334 117.363L55.2676 130.27Z",
    fill: "#DCDCDC"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7246 131.698L97.6577 154.953L117.547 143.46L77.6326 120.189L57.7246 131.698Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3867 159.169V174.249L93.1254 176.414V175.514L90.2495 173.85V159.662L89.3867 159.169Z",
    fill: "#BCBCBC"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M90.25 159.661V173.849L93.1259 175.513V161.33L90.25 159.661Z",
    fill: "#DCDCDC"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9648 155.977V171.057L87.7036 173.222V172.322L84.825 170.655V156.469L83.9648 155.977Z",
    fill: "#BCBCBC"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8262 156.468V170.654L87.7048 172.321V158.138L84.8262 156.468Z",
    fill: "#DCDCDC"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M78.541 152.78V167.86L82.2824 170.025V169.128L79.4038 167.461V153.276L78.541 152.78Z",
    fill: "#BCBCBC"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4043 153.275V167.461L82.2829 169.128V154.942L79.4043 153.275Z",
    fill: "#DCDCDC"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1191 149.586V164.667L76.8579 166.831V165.931L73.982 164.267V150.082L73.1191 149.586Z",
    fill: "#BCBCBC"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9824 150.083V164.268L76.8584 165.932V151.749L73.9824 150.083Z",
    fill: "#DCDCDC"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M106.558 159.169V174.249L102.816 176.414V175.514L105.695 173.85V159.662L106.558 159.169Z",
    fill: "#BCBCBC"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M105.695 159.661V173.849L102.816 175.513V161.33L105.695 159.661Z",
    fill: "#DCDCDC"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M111.977 155.975V171.055L108.238 173.22V172.32L111.117 170.653V156.467L111.977 155.975Z",
    fill: "#BCBCBC"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M111.117 156.466V170.652L108.238 172.319V158.136L111.117 156.466Z",
    fill: "#DCDCDC"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M117.402 152.779V167.859L113.66 170.024V169.126L116.539 167.459V153.274L117.402 152.779Z",
    fill: "#BCBCBC"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M116.539 153.274V167.459L113.66 169.126V154.941L116.539 153.274Z",
    fill: "#DCDCDC"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M122.821 149.586V164.667L119.08 166.831V165.931L121.959 164.267V150.082L122.821 149.586Z",
    fill: "#BCBCBC"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M121.959 150.082V164.267L119.08 165.931V151.749L121.959 150.082Z",
    fill: "#DCDCDC"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2656 146.252V161.332L71.0044 163.497V162.597L68.1257 160.933V146.747L67.2656 146.252Z",
    fill: "#BCBCBC"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M68.127 146.748V160.933L71.0056 162.598V148.415L68.127 146.748Z",
    fill: "#DCDCDC"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8438 143.057V158.139L65.5825 160.304V159.404L62.7039 157.737V143.552L61.8438 143.057Z",
    fill: "#BCBCBC"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7031 143.553V157.738L65.5818 159.405V145.222L62.7031 143.553Z",
    fill: "#DCDCDC"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M56.418 139.863V154.943L60.1594 157.108V156.211L57.2808 154.544V140.359L56.418 139.863Z",
    fill: "#BCBCBC"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2812 140.358V154.544L60.1599 156.211V142.028L57.2812 140.358Z",
    fill: "#DCDCDC"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M51 136.67V151.75L54.7361 153.915V153.018L51.8575 151.348V137.165L51 136.67Z",
    fill: "#BCBCBC"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8574 137.166V151.349L54.736 153.018V138.833L51.8574 137.166Z",
    fill: "#DCDCDC"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M173.348 155.809L173.356 186.238L142.919 203.957L142.916 173.528L173.348 155.809Z",
    fill: "url(#paint3_linear_11642_35503)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M142.916 173.528L142.919 203.957L115.072 187.878L115.064 157.449L142.916 173.528Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M173.348 155.808L142.916 173.527L115.064 157.449L145.499 139.729L173.348 155.808Z",
    fill: "#F4F4F9"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M167.871 155.817L165.413 157.244L145.505 145.735L123.016 158.847L120.559 157.436L145.505 142.91L167.871 155.817Z",
    fill: "#DCDCDC"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M165.412 157.244L142.902 170.341L123.016 158.848L145.504 145.735L165.412 157.244Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11642_35503",
    x: 0.154297,
    y: 91.4751,
    width: 255.051,
    height: 170.808,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.23 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11642_35503"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11642_35503",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11642_35503",
    x1: 227.482,
    y1: 161.995,
    x2: 27.5765,
    y2: 161.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D6DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE6E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11642_35503",
    x1: 97.3899,
    y1: 67.7825,
    x2: 203.52,
    y2: 130.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11642_35503",
    x1: 153.137,
    y1: 94.7848,
    x2: 225.302,
    y2: 137.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11642_35503",
    x1: 138.677,
    y1: 168.303,
    x2: 177.915,
    y2: 191.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultBsProjectCard);
export default __webpack_public_path__ + "static/media/DefaultBsProjectCard.c2996d0ed734693fe03f05a69a5c30d4.svg";
export { ForwardRef as ReactComponent };